import React, { useMemo, useState } from 'react';
import QRCode from 'react-qr-code';
import Chat from "../components/common/Chat";
import Toolbar from "../navigation/Toobar";
import Header from "../layout/Header";
import useReferralData from '../hooks/useReferralData';
import { claimAllReferralRewards } from '../services/referralService';
import '../styles/referral.css';

function Referral({userData, showAlert}){
    const [claiming, setClaiming] = useState(false);
  const { summary, rewardHistory, loading, error, refresh } = useReferralData(userData);
    const referralCode = summary?.referral_code || userData?.referral_code || '-';
    const referralLink = summary?.referral_url || `${window.location.origin}/referral_code?referral_code=${referralCode}`;

    const metrics = useMemo(() => ([
      { id: 'activeDownLineCount', label: 'Active Downlines', value: summary?.active_downlines ?? 0 },
      { id: 'requiredDeposit', label: 'Required Deposit', value: `৳ ${summary?.required_deposit ?? 0}` },
      { id: 'requiredTurnover', label: 'Required Turnover', value: `৳ ${summary?.required_turnover ?? 0}` },
      { id: 'lifeTimeCashRewards', label: 'Lifetime Cash Rewards', value: `৳ ${summary?.lifetime_cash_rewards ?? 0}` },
      { id: 'referralTurnover', label: 'Referral Turnover', value: `৳ ${summary?.referral_turnover ?? 0}` },
      { id: 'cashRewards', label: 'Current Cash Rewards', value: `৳ ${summary?.cash_rewards ?? 0}` },
    ]), [summary]);

    const copyReferralLink = async () => {
        try {
            await navigator.clipboard.writeText(referralLink);
            showAlert('Referral link copied');
        } catch (error) {
            window.prompt('Copy this link:', referralLink);
        }
    };

    const shareReferralLink = () => {
        if (navigator.share) {
            navigator.share({
                title: 'Join me on this platform!',
                text: `Use my referral code to sign up: ${referralCode}`,
                url: referralLink,
            }).catch(console.error);
        } else {
            showAlert('Sharing is not supported on this device.');
        }
	};

   const claimAll = async () => {
    const cashRewards = Number(summary?.cash_rewards || 0);
    if (cashRewards <= 0) {
      showAlert('No pending cash reward to claim.');
      return;
    }

    const token = localStorage.getItem('token');
    const remoteId = localStorage.getItem('remote_id');
    if (!token || !remoteId) {
      showAlert('Please login again.');
      return;
    }

    setClaiming(true);
    try {
      const response = await claimAllReferralRewards(remoteId, token);
      showAlert(response?.message || 'Claim completed');
      await refresh();
    } catch (claimError) {
      showAlert(claimError?.message || 'Failed to claim reward. Please try again.');
    } finally {
      setClaiming(false);
    }
  };

  const formatDate = (value) => {
    if (!value) {
      return '-';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '-';
    }
    return date.toLocaleString('en-GB');
  };

  const hasNoData = !loading && !error && !rewardHistory.length;

 return(
    <div className="v-application--wrap">
  <div>
    {/**/}
    <div className="row no-gutters">
      <Header/>
    </div>
   
 
   
    <div className="body">
      <div className="referral-page-wrap">
        <div className="mx-4 my-3 referral-main-card v-card v-sheet theme--dark">
          <div className="v-card__text">
            <div className="referral-page-title">Referral Program</div>
            <div className="referral-page-subtitle">Invite friends, claim rewards, and convert referral points to cash.</div>

            {error ? <div className="referral-global-error">{error}</div> : null}

            <div className="row no-gutters referral-metric-grid">
              {metrics.map((metric) => (
                <div key={metric.id} className="pa-1 col col-6">
                  <div className="referral-metric-card v-card v-sheet theme--dark">
                    <div className="v-card__text">
                      <div className="referral-metric-label">{metric.label}</div>
                      <div id={metric.id} className="referral-metric-value">{metric.value}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-3 referralCode-card v-card v-sheet theme--dark">
              <div className="v-card__text">
                <div className="referral-section-title">Referral Code & Share</div>
                <div className="referral-code-value">{referralCode}</div>
                <div className="referral-link-text">{referralLink}</div>
                <div className="referral-share-actions">
                  <button type="button" onClick={copyReferralLink} className="rebate-redeem-btn v-btn v-btn--has-bg theme--dark v-size--default">
                    <span className="v-btn__content">Copy Link</span>
                  </button>
                  <button type="button" onClick={shareReferralLink} className="rebate-redeem-btn v-btn v-btn--has-bg theme--dark v-size--default">
                    <span className="v-btn__content">Share</span>
                  </button>
                </div>
                <div className="qrCode mt-3">
                  <QRCode value={referralLink || window.location.origin} size={122} bgColor="#ffffff" fgColor="#111111" />
                </div>
              </div>
            </div>

            <div className="mt-3 referral-ratio-board v-card v-sheet theme--dark">
              <div className="v-card__text">
                <div className="referral-section-title">Program Ratio Board</div>
                <div className="row no-gutters">
                  <div className="pa-1 col col-4"><div className="referral-ratio-chip">Tier 1: 2.5%</div></div>
                  <div className="pa-1 col col-4"><div className="referral-ratio-chip">Tier 2: 1.5%</div></div>
                  <div className="pa-1 col col-4"><div className="referral-ratio-chip">Tier 3: 1.0%</div></div>
                </div>
              </div>
            </div>

            <div className="mt-3 referral-claim-card v-card v-sheet theme--dark">
              <div className="v-card__text">
                <div className="referral-section-title">Claim Cash Reward</div>
                <div className="claim-amount v-card v-sheet theme--dark">৳ {summary?.cash_rewards || 0}</div>
                <button
                  id="claimAll"
                  type="button"
                  onClick={claimAll}
                  className="mt-2 rebate-redeem-btn v-btn v-btn--has-bg theme--dark v-size--default"
                  disabled={claiming || Number(summary?.cash_rewards || 0) <= 0}
                >
                  <span className="v-btn__content">{claiming ? 'Claiming...' : 'Claim All'}</span>
                </button>
              </div>
            </div>

            <div className="mt-3 history-card v-card v-sheet theme--dark">
              <div className="v-card__text">
                <div className="referral-section-title">Cash Reward History</div>
                <div className="row referral-table-header pl-2 no-gutters">
                  <div className="col col-4">Date</div>
                  <div className="col col-4">Turnover</div>
                  <div className="col col-4">Reward</div>
                </div>
                {rewardHistory.length ? rewardHistory.map((row, index) => (
                  <div key={`${row?.id || 'reward'}-${index}`} className="row referral-table-row pl-2 no-gutters">
                    <div className="col col-4">{formatDate(row?.created_at)}</div>
                    <div className="col col-4">৳ {row?.turnover ?? 0}</div>
                    <div className="col col-4">৳ {row?.cash_reward ?? 0}</div>
                  </div>
                )) : <div className="referral-empty">No reward history found.</div>}
              </div>
            </div>

            {loading ? <div className="referral-loading">Loading referral data...</div> : null}
            {hasNoData ? <div className="referral-note">No referral activities yet.</div> : null}
          </div>
        </div>
      </div>
    </div>
  <Toolbar/>
   <Chat/>
  </div>
</div>

 );
}
export default Referral;